import { Button, LinkButton, Modal } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';
import { selectModalStatus, selectModalVisible } from 'shared/selectors/modal';
import { setVisible } from 'shared/slices';
import { EBonusStatus } from 'shared/types/bonusStatus';
import { AuthenticationContainer } from '../AuthenticationContainer';
import { ResultModalContent } from 'shared/components/ResultModalContent';
import { MODAL_CONTENT } from './constants';
import { LK_LINK } from 'shared/constants/links';

export const ModalContainer: React.FC = () => {
  const status = useSelector(selectModalStatus);
  const visible = useSelector(selectModalVisible);

  const dispatch = useAppDispatch();

  const handleModalVisible = () => {
    dispatch(setVisible(false));
  };

  const handleReloadPage = () => {
    window.location.reload();
  };

  const renderContent = () => {
    switch (status) {
      case EBonusStatus.Init:
      default:
        return <AuthenticationContainer />;

      case EBonusStatus.Applied:
        return (
          <ResultModalContent
            {...MODAL_CONTENT[0]}
            btn={
              <LinkButton href={LK_LINK} target="_blank">
                {MODAL_CONTENT[0].btnText}
              </LinkButton>
            }
          />
        );

      case EBonusStatus.Awarded:
        return (
          <ResultModalContent
            {...MODAL_CONTENT[3]}
            btn={
              <LinkButton href={LK_LINK} target="_blank">
                {MODAL_CONTENT[3].btnText}
              </LinkButton>
            }
          />
        );

      case EBonusStatus.Canceled:
        return (
          <ResultModalContent
            {...MODAL_CONTENT[1]}
            btn={
              <LinkButton href={LK_LINK} target="_blank">
                {MODAL_CONTENT[1].btnText}
              </LinkButton>
            }
          />
        );

      case EBonusStatus.Error:
        return (
          <ResultModalContent
            {...MODAL_CONTENT[2]}
            btn={<Button onClick={handleReloadPage}>{MODAL_CONTENT[2].btnText}</Button>}
          />
        );
    }
  };

  return <Modal onOpenChange={handleModalVisible} open={visible} body={renderContent()} />;
};
